<style scoped>
  tr.reactiveError {
    border: 2px solid red;
  }

  tr.reactiveError:focus-within {
    border: none;
  }

  td:focus-within div.reactiveError {
    display: none;
  }

  div.reactiveError {
    position: absolute;
    background: #d00;
    display: inline-block;
    color: #fff;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
    margin-left: -12px;
    margin-top: -20px;
    padding: 3px 6px;
    border-radius: 5px; /* CSS3草案 */
    -webkit-border-radius: 5px; /* Safari,Google Chrome用 */
    -moz-border-radius: 5px; /* Firefox用 */
    font-size: 12px;
  }

  div.reactiveError::after {
    content: "▼";
    position: absolute;
    left: 2em;
    bottom: -0.8em;
    display: block;
    color: #d00;
    line-height: 1em;
    font-size: 1em;
  }
</style>
<template>
  <div class="reactiveError" v-if="errorMessages">
    {{errorMessages}}
  </div>
</template>
<script>
  export default {
    name: 'ErrorMessageBalloon',
    props: ['errorMessages'],
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Utility/ErrorMessageBalloon.vue